export const GET_PROPOSALS = 'proposal:GET_PROPOSALS';
export const GET_PROPOSALS_SUCCESS = 'proposal:GET_PROPOSALS_SUCCESS';
export const GET_PROPOSALS_ERROR = 'proposal:GET_PROPOSALS_ERROR';

export const SET_PROPOSAL_PILOT = 'proposal:SET_PROPOSAL_PILOT';
